import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"
import DatePicker from "react-datepicker";
import moment from "moment";


function AddShortVideo() {

    const [videoenglishtitle, Setvideoenglishtitle] = useState("");
    const [videohindititle, Setvideohindititle] = useState("");
    const [videofile, Setvideofile] = useState();
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();
    const [scheduledate, setScheduledate] = useState(new Date())
    const [status, setStatus] = useState("published")
    const [showDate, setShowdate] = useState(false)
    document.title = "Add Short Video-Jain Sadhana";

    const showSchedule = () => {
        setShowdate(!showDate)
        if (showDate === true) {
            setStatus("published")
        }
        else {
            setStatus("scheduled")
        }
    };


    const HandleAdd = async (event) => {
        Setloading(true)
        event.preventDefault();
        const data = new FormData();
        data.append('videoenglishtitle', videoenglishtitle);
        data.append('videohindititle', videohindititle);
        data.append('videofile', videofile);
        data.append("status", status)
        data.append("scheduledate", moment(scheduledate).format("YYYY-MM-DD"))

        try {
            const response = await axios.post("api/shortvideo/addshortvideo", data)
            if (response.status === 200) {
                navigate('/menu/shortvideolist')
                toast.success(' Short Video Added Successfully')
                Setloading(false)
            }
        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" shortvideo="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black'  >Add New Short Video</p>
                                    <Link to="/menu/shortvideolist" className='text-black btn button-yellow  back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All Short Video</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleAdd}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6 text-center'>
                                                        <label className='label-style'>English Title</label>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setvideoenglishtitle(event.target.value)} className="form-control  bg-gray border border-0" id="videoenglishtitle" name='videoenglishtitle' placeholder="Short Video English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6 text-center">
                                                        <label className='label-style'>Hindi Title</label>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setvideohindititle(event.target.value)} className="form-control  bg-gray border border-0" id="videohindititle" name='videohindititle' placeholder="Short Video Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label className='label-style text-center'>Upload Video File</label>
                                                    <div className="col-12">
                                                        <div className=" mb-3">
                                                            <input name="videofile" onChange={(e) => Setvideofile(e.target.files[0])} type="file" className="form-control " id="upload-file" required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="align-items-center gap-2 mb-2 ">
                                                    <input type='checkbox' onClick={showSchedule} id='checkbox' />
                                                    <label className="label-style" htmlFor='checkbox'>Click on the Checkbox to Schedule </label>
                                                    {
                                                        showDate === true ? <div>
                                                            <label className="label-style d-block ms-4">Enter Schedule Date</label>
                                                            <DatePicker selected={scheduledate} minDate={new Date()} onChange={(date) => setScheduledate(date)} className="width50 form-control ms-4 border border-2 border-dark" />
                                                        </div> : ""
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/shortvideolist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddShortVideo